export default "__VITE_ASSET__Cvs2l_UX__"